<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>权限管理</el-breadcrumb-item>
      <el-breadcrumb-item>菜单管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <!-- 添加角色信息按钮 -->
      <el-row>
        <el-col>
          <el-button type="primary" size="mini" plain icon="el-icon-plus" @click="addDialogVisible = true"
            class="btn1">新增</el-button>
        </el-col>
      </el-row>
      <div>
        <!-- 菜单信息表格 -->
        <el-table :data="MenuList" style="width: 100%; margin-bottom: 20px" row-key="ID" default-expand-all
          :tree-props="{ children: 'children' }">
          <el-table-column prop="MenuName" label="菜单" align="center"></el-table-column>
          <el-table-column prop="path" label="路径" align="center"> </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-edit" size="mini" @click="showEditDialog(scope)">编辑</el-button>
              <el-button type="text" icon="el-icon-delete" size="mini" @click="removeMenu(scope)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>

    <!-- 添加菜单的对话框 -->
    <el-dialog title="添加菜单" :visible.sync="addDialogVisible" width="20%" @close="addDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="90px">
        <el-form-item label="菜单名" prop="MenuName" required>
          <el-input v-model="addForm.MenuName" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="级别" prop="level" required>
          <el-select v-model="addForm.level" placeholder="请选择菜单级别">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <div v-if="addForm.level == '2'">
          <el-form-item label="路径" prop="path" required>
            <el-input v-model="addForm.path" style="width: 90%" size="medium"></el-input>
          </el-form-item>
        </div>
        <div v-if="addForm.level == '2'">
          <el-form-item label="父ID" prop="ParentID" required>
            <el-select v-model="addForm.ParentID" placeholder="请选择用户类型" @change="selectNum($event)">
              <el-option v-for="item in parentMenu" :key="item.ID" :label="item.MenuName"
                :value="item.ID + ''"></el-option>
              <!-- :value="{ code: item.ID, IDS: item.MenuName }"></el-option> -->
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="addDialogVisible = false">取 消</el-button>
        <el-button size="medium" type="primary" @click="addMenu()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑菜单信息的会话框 -->
    <el-dialog title="修改菜单信息" :visible.sync="editDialogVisible" width="20%" @close="editDialogClose">
      <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="80px">
        <el-form-item label="菜单名" prop="MenuName" required>
          <el-input v-model="editForm.MenuName" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <div v-if="this.editFormLevel == '2'">
          <el-form-item label="级别" prop="level">
            <el-select v-model="addForm.level" placeholder="请选择用户类型">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div v-if="this.editFormLevel == '2' && this.addForm.level == '2'">
          <el-form-item label="路径" prop="path" required>
            <el-input v-model="editForm.path" style="width: 90%" size="medium"></el-input>
          </el-form-item>
        </div>
        <div v-if="this.editFormLevel == '2' && this.addForm.level == '2'">
          <el-form-item label="父ID" prop="ParentID" required>
            <el-select v-model="editForm.ParentID" placeholder="请选择用户类型" @change="selectNum($event)">
              <el-option v-for="item in parentMenu" :key="item.ID" :label="item.MenuName"
                :value="item.ID + ''"></el-option>
              <!-- :value="{ code: item.ID, IDS: item.MenuName }"></el-option> -->
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="editDialogVisible = false">取 消</el-button>
        <el-button size="medium" type="primary" @click="editMenu">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      getTypeList: {
        page: '1',
        limit: '5000',
        privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
        appIdentification: 'wms',
        tableName: 'main_menu'
      },
      // 菜单信息表
      MenuList: [],
      // 父级菜单信息表
      parentMenu: [],
      // 添加菜单的表单数据
      addForm: {
        MenuName: '',
        path: '',
        ParentID: '',
        ParentName: '',
        level: ''
      },
      addFormRules: [],
      // 数据总条数
      total: 0,
      //控制添加表单的显示与隐藏
      addDialogVisible: false,
      //控制修改表单的显示与隐藏
      editDialogVisible: false,
      // 编辑信息的表单数据
      editForm: {},
      // 修改表单的验证规则对象
      editFormRules: {
        StorageLocationNO: [
          { required: true, message: '请输入储位编号', trigger: 'blur' },
        ],
        WarehouseSet_ID: [
          { required: true, message: '请输入仓库管理标识符', trigger: 'blur' },
        ],
        Main_ProductSet_ID: [
          { required: true, message: '请输入产品设置标识符', trigger: 'blur' },
        ],
        QTY: [
          { required: true, message: '请输入产品数量', trigger: 'blur' },
        ],
      },
      //目录级别选择
      options: [{
        value: '1',
        label: '一级'
      }, {
        value: '2',
        label: '二级'
      }],
      // 修改用级别
      editFormLevel: '',
      oldMenuList: [],
    }
  },
  created() {
    this.getMenuList()
    this.getParentMenuList()
  },
  methods: {
    // 调用接口获取菜单信息
    async getMenuList() {
      const { data: res } = await this.$http.get('/User/getMenu', { params: this.getTypeList })
      console.log(res)
      this.MenuList = this.setTreeData(res.data)
      this.oldMenuList = res.data
    },
    // 给父级数据添加children属性
    setTreeData(source) {
      let cloneData = JSON.parse(JSON.stringify(source))
      return cloneData.filter(father => {
        let branchArr = cloneData.filter(child => father.ID == child.ParentID);
        branchArr.length > 0 ? father.children = branchArr : ''
        return father.ParentID == 0;
      });
    },
    // 获取父级菜单数据
    async getParentMenuList() {
      const { data: res } = await this.$http.get('/User/getMenu', { params: this.getTypeList })
      console.log(res)
      let result = res.data.filter(function (num) {
        return num.ParentID == 0
      })
      this.parentMenu = result
    },
    selectNum(event) {
      console.log(event)
      const list = this.oldMenuList;
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        if (element.ID == event) {
          this.addForm.ParentID = element.ID + ""
          this.addForm.ParentName = element.MenuName
          this.editForm.ParentID = element.ID + ""
          this.editForm.ParentName = element.MenuName
          break
        }
      }
      // this.addForm.ParentID = event.code
      // this.addForm.ParentName = event.IDS
      // this.editForm.ParentID = event.code
      // this.editForm.ParentName = event.IDS
    },
    // 调用接口删除菜单信息
    async removeMenu(scope) {
      const confirmResult = await this.$confirm(
        '此操作将永久删除该信息, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err)

      if (confirmResult !== 'confirm') {
        return this.$message.info('已经取消删除！')
      }
      let params = new URLSearchParams();
      params.append("ID", scope.row.ID)
      params.append("MenuName", scope.row.MenuName)
      params.append("ParentID", scope.row.ParentID)
      params.append("path", scope.row.path)
      params.append("ParentName", scope.row.ParentName)
      // params.append("MenuIcon", scope.row.MenuIcon)
      params.append("privateKey", this.getTypeList.privateKey)
      params.append("appIdentification", this.getTypeList.appIdentification)
      console.log('89' + params)
      const { data: res } = await this.$http.post('/User/DeleteMenu', params)
      console.log(res)
      if (res.code !== 1) {
        return this.$message.error('删除失败！')
      } else {
        this.$message.success('删除成功！')
      }
      this.getMenuList()
    },
    //  监听添加信息对话框的关闭事件
    addDialogClosed() {
      this.$refs.addFormRef.resetFields()
    },
    // 调用接口添加菜单信息
    addMenu() {
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) return
        let params = new URLSearchParams();
        params.append("privateKey", this.getTypeList.privateKey)
        params.append("appIdentification", this.getTypeList.appIdentification)
        params.append("MenuName", this.addForm.MenuName)
        params.append("ParentID", this.addForm.ParentID)
        params.append("path", this.addForm.path)
        params.append("ParentName", this.addForm.ParentName)
        console.log('554' + params)
        const { data: res } = await this.$http.post('/User/InsertMenu', params)
        console.log(res.data)
        if (res.code != 1) {
          return this.$message.error('添加菜单失败！')
        } else {
          this.$message.success('添加菜单成功！')
        }
        // 隐藏添加信息的对话框
        this.addDialogVisible = false
        // 重新获取仓库储位信息列表数据
        this.getMenuList()
      })
    },
    // 监听修改信息对话框的关闭事件
    editDialogClose() {
      this.$refs.editFormRef.resetFields()
    },
    // 展示修改菜单信息的对话框
    async showEditDialog(scope) {
      this.editDialogVisible = true
      let params = new URLSearchParams();
      params.append("ID", scope.row.ID)
      params.append("privateKey", this.getTypeList.privateKey)
      params.append("appIdentification", this.getTypeList.appIdentification)
      params.append("tableName", this.getTypeList.tableName)
      const { data: res } = await this.$http.get('/WMS/GeneralQueryID', { params })
      console.log(res.data)
      if (res.data[0].ParentID == '0') {
        this.editFormLevel = '1'
        this.addForm.level = '1'
      } else {
        this.editFormLevel = '2'
        this.addForm.level = '2'
      }
      console.log(this.addForm.level)
      this.editForm = res.data[0]
    },
    // 调用接口编辑角色信息
    editMenu() {
      this.$refs.editFormRef.validate(async valid => {
        if (!valid) return
        if (this.addForm.level == '1') {
          this.editForm.ParentID = '0'
        }
        let params = new URLSearchParams();
        params.append("privateKey", this.getTypeList.privateKey)
        params.append("appIdentification", this.getTypeList.appIdentification)
        params.append("ID", this.editForm.ID)
        params.append("MenuName", this.editForm.MenuName)
        params.append("ParentID", this.editForm.ParentID)
        params.append("path", this.editForm.path)
        params.append("ParentName", this.editForm.ParentName)
        console.log('123' + params)
        const { data: res } = await this.$http.post('/User/UpdateMenu', params)
        console.log(res)
        if (res.code != 1) {
          return this.$message.error('更新菜单信息失败！')
        } else {
          this.$message.success('更新菜单信息成功！')
        }
        // 关闭对话框
        this.editDialogVisible = false
        // 刷新数据列表
        this.getMenuList()
      })
    },
  }
}
</script>

<style lang="less" scoped>
.btn1 {
  margin-bottom: 10px;
}
</style>
